export const ROLES = {
  FACILITY_USER: 'Facility User',
  CASE_MANAGER: 'Case Manager',
} as const;

export type UserRole = (typeof ROLES)[keyof typeof ROLES];
